import { Check } from "lucide-react";

const TRIAL_LINE = "First 6 months FREE — nothing taken until then";
const FEATURES = [
  TRIAL_LINE,
  "Your own web address — extras.tv/yourname",
  "Add up to 8 photos and write about yourself",
  "Share your page in Facebook groups, WhatsApp and anywhere else",
  "Appear in searches for your area",
  "Get emailed about casting calls near you",
  "Choose how casting people contact you",
  "Private inbox for enquiries",
  "Renews yearly — cancel any time",
  "Adults 18+ only",
];

export const PricingCard = ({ children, testId = "pricing-card", price = "£10", note = null, showTrial = true }) => (
  <div className="beam p-[1px]" data-testid={testId}>
    <div className="p-8 md:p-10">
      <p className="label-xs text-primary">Annual subscription</p>
      <div className="flex items-end gap-2 mt-4">
        <span className="font-display text-7xl font-bold leading-none" data-testid="pricing-amount">{price}</span>
        <span className="text-white/60 mb-2">/ year</span>
      </div>
      {note && <p className="text-xs text-white/50 mt-3">{note}</p>}
      <ul className="mt-8 space-y-3">
        {FEATURES.filter((f) => showTrial || f !== TRIAL_LINE).map((f) => (
          <li key={f} className="flex items-start gap-3 text-sm text-white/80">
            <Check size={16} className="text-primary mt-0.5 shrink-0" />
            {f}
          </li>
        ))}
      </ul>
      {children && <div className="mt-10">{children}</div>}
    </div>
  </div>
);
